import { Fold } from './Fold'
import type { Source } from '../types'

const LABEL: Record<Source['sourceType'], string> = {
  doc: 'doc',
  policy: 'policy',
  past_ticket: 'past ticket',
}

/** Shown so the agent can see *why* the model said what it said. */
export function SourceList({ sources }: { sources: Source[] }) {
  if (!sources.length) return null

  const names = new Set(sources.map((s) => s.source))

  return (
    <Fold
      title="Grounded in"
      count={`${names.size} document${names.size === 1 ? '' : 's'}`}
    >
      <ul className="sources">
        {sources.map((s, i) => (
          <li key={`${s.source}-${i}`}>
            <span className="tag">{LABEL[s.sourceType] ?? s.sourceType}</span>
            {s.source}
          </li>
        ))}
      </ul>
    </Fold>
  )
}
